/**
 * Return the height of the viewport. This probably needs to be more thorough.
 */
var getViewportHeight = function getViewportHeight() {
  return window.innerHeight;
};

export default getViewportHeight;